// src/utils/streamUtils.ts

/**
 * Reads a stream of newline-separated JSON strings.
 */
export async function readJsonStream<T>(
  reader: ReadableStreamDefaultReader<Uint8Array>,
  onUpdate: (data: T) => void,
): Promise<void> {
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const lines = buffer.split("\n");

      // Keep the last partial line in the buffer
      buffer = lines.pop() || "";

      for (const line of lines) {
        if (line.trim()) {
          try {
            const data = JSON.parse(line) as T;
            onUpdate(data);
          } catch (e) {
            console.error("Error parsing stream chunk", e);
          }
        }
      }
    }
  } catch (error) {
    throw error;
  } finally {
    reader.releaseLock();
  }
}
